import { Component } from '@verndale/core';
import 'slick-carousel';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $slider: this.el.querySelector('.content-cards__cards'),
      $cards: this.el.querySelectorAll('.content-card')
    };

    this.slide();
  }

  addListeners() {
    $(this.dom.$slider).on('click', '.content-card', e => {
      const slide = e.target.closest('.slick-slide');

      if (!slide) return;

      let idx = slide.dataset.slickIndex;

      if (slide.classList.contains('slick-current')) return;

      e.preventDefault();
      idx = parseInt(idx);
      $(this.dom.$slider).slick('slickGoTo', idx);
    });
  }

  slide() {
    $(this.dom.$slider).slick({
      centerMode: true,
      arrows: false,
      dots: true,
      mobileFirst: true,
      centerPadding: '50px',
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
      ]
    });
  }
}

export default Module;
